import { render } from "./ProductCard.vue?vue&type=template&id=7cc12327&ts=true"
import script from "./ProductCard.vue?vue&type=script&lang=ts"
export * from "./ProductCard.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\keerag\\Downloads\\vsts-agent-win-x64-5.278.0\\_work\\5\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__